<div class="page-title">
  <div class="title" [innerHTML]="'PersonalInfo.First.Title' | translate | safe:'html'"></div>
  <div class="sub-title" [innerHTML]="'PersonalInfo.First.SubTitle' | translate | safe:'html'"></div>
</div>

<app-personal
  [(userModel)]="user"
  [forbiddenEmails]="[user.secondHolder.email]"
  (userModelChange)="updateUser()"
></app-personal>
